import * as React from 'react';

import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';
import { Form, FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import ActionButton from 'components/buttons/action-button/ActionButton';
import PromptExit from '../../../libs/router/prompt-exit/PromptExit';

import { isRequired } from 'utils/validators';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

import type { TextEntry } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  onCloseModal: () => void,
  onSubmit: (a: string) => void,
  title: string,
  label: string,
  value: string,
  multiline?: boolean,
  keepOpen?: boolean,
  okBtnText: string
};

type State = {
  isModified: boolean,
  value: string
};

class PromptModal extends React.PureComponent<Props, State> {
  state = {
    isModified: false,
    value: this.props.value
  };

  handleFieldChanged = (event: SyntheticEvent<TextEntry>) => {
    const value = event.currentTarget.value;

    this.setState(state => ({
      ...state,
      value,
      isModified: true
    }));
  };

  handleSubmit = () => {
    const { keepOpen, onCloseModal, onSubmit } = this.props;
    const { value } = this.state;

    onSubmit(value);

    if (!keepOpen) {
      onCloseModal();
    }
  };

  render() {
    const { onCloseModal, title, label, okBtnText, multiline } = this.props;
    const { isModified, value } = this.state;

    return (
      <ModalFrame
        title={title}
      >
        {
          isModified &&
          <PromptExit type="modal" />
        }
        <ModalFrameInner
          narrowContent
        >
          <Form onSubmit={this.handleSubmit}>
            <FormField
              direction="column"
              label={label}
              labelType="highlighted"
              fontSize="small"
              showValidationIcon={false}
              showRequiredMark
              validators={[
                isRequired(value)
              ]}
            >
              <Input
                name="input"
                value={value}
                width="responsive"
                multiline={multiline}
                onChange={this.handleFieldChanged}
              />
            </FormField>
            <ModalFrameFooter>
              <ActionButton
                color="tertiary"
                onClick={onCloseModal}
              >
                {__t('collabary_common.action_button.cancel')}
              </ActionButton>
              <ActionButton
                type="submit"
                color="secondary"
              >
                {okBtnText}
              </ActionButton>
            </ModalFrameFooter>
          </Form>
        </ModalFrameInner>
      </ModalFrame>
    );
  }
}

export default PromptModal;
